import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import style from './styles/title.module.scss'

const Title = ({
  children,
  type,
  hidden = false,
  ...props
}): React.ReactElement => {
  const CustomTag = type
  const { className = '', theme = type } = props

  return (
    <CustomTag
      className={classNames({
        [style[theme]]: theme,
        [className]: className,
        hidden: hidden
      })}
    >
      {children}
    </CustomTag>
  )
}

Title.defaultProps = {
  type: 'h1',
  hidden: false
}

Title.propTypes = {
  type: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  theme: PropTypes.string,
  children: PropTypes.node,
  hidden: PropTypes.bool
}

export default Title
